import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactAndHelpComponent } from './components/contact-and-help/contact-and-help.component';
import { ContactHelpComponent } from './components/contact-help/contact-help.component';

const routes: Routes = [
  {
    path: '',
    component: ContactHelpComponent,
    children: [
      {
        path: '',
        redirectTo: 'Help',
        pathMatch: 'full',
        data: {
          breadcrumb: 'contact-and-help.self'
        }
      },
      {
        path: 'Help',
        component: ContactAndHelpComponent,
        data: {
          breadcrumb: 'contact-and-help.self'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContactHelpRoutingModule {}
